var _path, _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoingWell2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 89,
    viewBox: "0 0 87 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9175 9.80211L20.191 16.4275C11.222 18.8307 7.40715 25.4815 9.81827 34.4799L17.9845 64.9565C20.4351 74.1024 27.0327 77.8367 36.0016 75.4335L60.7281 68.808C69.8416 66.3661 73.5406 59.8729 71.0899 50.7269L62.9237 20.2504C60.5126 11.252 54.0309 7.36016 44.9175 9.80211Z",
    fill: "url(#paint0_linear_112_1033)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_112_1033)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.4456,
    height: 33.403,
    transform: "matrix(-0.25882 -0.965926 0.965926 -0.258818 27.9971 64.801)",
    fill: "#0062FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_112_1033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.1695 25.5728H42.5707C33.2854 25.5728 27.8792 31.0095 27.8792 40.3254V71.877C27.8792 81.3456 33.2854 86.6602 42.5707 86.6602H68.1695C77.6044 86.6602 82.858 81.3456 82.858 71.877V40.3254C82.858 31.0095 77.6044 25.5728 68.1695 25.5728Z",
    fill: "url(#paint1_linear_112_1033)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1695 25.1125H42.5707C37.8386 25.1125 34.0361 26.4996 31.4167 29.1309C28.7977 31.7619 27.4189 35.5791 27.4189 40.3254V71.877C27.4189 76.6978 28.7967 80.524 31.4175 83.1448C34.0382 85.7655 37.8414 87.1204 42.5707 87.1204H68.1695C72.9719 87.1204 76.776 85.7664 79.3786 83.1435C81.9806 80.5212 83.3182 76.6943 83.3182 71.877V40.3254C83.3182 35.5826 81.9796 31.7648 79.3793 29.1322C76.7781 26.4987 72.9747 25.1125 68.1695 25.1125Z",
    stroke: "url(#paint2_linear_112_1033)",
    strokeWidth: 0.920535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_112_1033)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_112_1033",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3952 39.7766V39.8072C42.0788 39.8072 41.0128 40.8762 41.0128 42.1896C41.0128 43.5029 42.0788 44.572 43.3952 44.572H52.5248C53.8412 44.572 54.9102 43.5029 54.9102 42.156C54.9102 40.8456 53.8412 39.7766 52.5248 39.7766H43.3952ZM67.3416 58.3786H43.3952C42.0788 58.3786 41.0128 57.3096 41.0128 55.9962C41.0128 54.6828 42.0788 53.6107 43.3952 53.6107H67.3416C68.6549 53.6107 69.724 54.6828 69.724 55.9962C69.724 57.3096 68.6549 58.3786 67.3416 58.3786ZM67.3417 72.337H43.3953C42.479 72.4591 41.5933 72.001 41.1046 71.2374C40.6159 70.4433 40.6159 69.4353 41.1046 68.6717C41.5933 67.8776 42.479 67.45 43.3953 67.5416H67.3417C68.5604 67.6638 69.4797 68.7023 69.4797 69.9546C69.4797 71.1733 68.5604 72.2148 67.3417 72.337Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3952 39.7766V39.8072C42.0788 39.8072 41.0128 40.8762 41.0128 42.1896C41.0128 43.5029 42.0788 44.572 43.3952 44.572H52.5248C53.8412 44.572 54.9102 43.5029 54.9102 42.156C54.9102 40.8456 53.8412 39.7766 52.5248 39.7766H43.3952ZM67.3416 58.3786H43.3952C42.0788 58.3786 41.0128 57.3096 41.0128 55.9962C41.0128 54.6828 42.0788 53.6107 43.3952 53.6107H67.3416C68.6549 53.6107 69.724 54.6828 69.724 55.9962C69.724 57.3096 68.6549 58.3786 67.3416 58.3786ZM67.3417 72.337H43.3953C42.479 72.4591 41.5933 72.001 41.1046 71.2374C40.6159 70.4433 40.6159 69.4353 41.1046 68.6717C41.5933 67.8776 42.479 67.45 43.3953 67.5416H67.3417C68.5604 67.6638 69.4797 68.7023 69.4797 69.9546C69.4797 71.1733 68.5604 72.2148 67.3417 72.337Z",
    fill: "url(#paint3_linear_112_1033)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3952 39.8072V39.9988H43.5869V39.8072H43.3952ZM43.3952 39.7766V39.585H43.2036V39.7766H43.3952ZM43.3953 72.337V72.1453H43.3826L43.37 72.147L43.3953 72.337ZM67.3417 72.337V72.5286H67.3513L67.3608 72.5277L67.3417 72.337ZM41.1046 71.2374L40.9413 71.3379L40.9431 71.3407L41.1046 71.2374ZM41.1046 68.6717L41.266 68.775L41.2678 68.7722L41.1046 68.6717ZM43.3953 67.5416L43.3763 67.7323L43.3858 67.7333H43.3953V67.5416ZM67.3417 67.5416L67.3608 67.3509L67.3513 67.35H67.3417V67.5416ZM43.5869 39.8072V39.7766H43.2036V39.8072H43.5869ZM41.2044 42.1896C41.2044 40.9819 42.1848 39.9988 43.3952 39.9988V39.6155C41.9728 39.6155 40.8212 40.7705 40.8212 42.1896H41.2044ZM43.3952 44.3803C42.1848 44.3803 41.2044 43.3973 41.2044 42.1896H40.8212C40.8212 43.6086 41.9728 44.7636 43.3952 44.7636V44.3803ZM52.5248 44.3803H43.3952V44.7636H52.5248V44.3803ZM54.7186 42.156C54.7186 43.3987 53.7338 44.3803 52.5248 44.3803V44.7636C53.9486 44.7636 55.1019 43.6072 55.1019 42.156H54.7186ZM52.5248 39.9683C53.7357 39.9683 54.7186 40.9518 54.7186 42.156H55.1019C55.1019 40.7395 53.9467 39.585 52.5248 39.585V39.9683ZM43.3952 39.9683H52.5248V39.585H43.3952V39.9683ZM43.3952 58.5702H67.3416V58.1869H43.3952V58.5702ZM40.8212 55.9962C40.8212 57.4152 41.9728 58.5702 43.3952 58.5702V58.1869C42.1848 58.1869 41.2044 57.2039 41.2044 55.9962H40.8212ZM43.3952 53.4191C41.9725 53.4191 40.8212 54.5774 40.8212 55.9962H41.2044C41.2044 54.7882 42.1851 53.8024 43.3952 53.8024V53.4191ZM67.3416 53.4191H43.3952V53.8024H67.3416V53.4191ZM69.9156 55.9962C69.9156 54.5773 68.7611 53.4191 67.3416 53.4191V53.8024C68.5488 53.8024 69.5323 54.7883 69.5323 55.9962H69.9156ZM67.3416 58.5702C68.7608 58.5702 69.9156 57.4154 69.9156 55.9962H69.5323C69.5323 57.2037 68.5491 58.1869 67.3416 58.1869V58.5702ZM43.3953 72.5286H67.3417V72.1453H43.3953V72.5286ZM40.9431 71.3407C41.4684 72.1614 42.4242 72.6598 43.4207 72.5269L43.37 72.147C42.5338 72.2585 41.7181 71.8405 41.266 71.1341L40.9431 71.3407ZM40.9431 68.5684C40.4134 69.3962 40.4155 70.4834 40.9413 71.3378L41.2678 71.137C40.8162 70.4032 40.8183 69.4745 41.266 68.775L40.9431 68.5684ZM43.4144 67.3509C42.4262 67.2521 41.4691 67.7137 40.9413 68.5713L41.2678 68.7722C41.7174 68.0415 42.5318 67.6479 43.3763 67.7323L43.4144 67.3509ZM67.3417 67.35H43.3953V67.7333H67.3417V67.35ZM69.6714 69.9546C69.6714 68.6075 68.681 67.4833 67.3608 67.3509L67.3226 67.7323C68.4397 67.8443 69.2881 68.7971 69.2881 69.9546H69.6714ZM67.3608 72.5277C68.6797 72.3954 69.6714 71.2694 69.6714 69.9546H69.2881C69.2881 71.0771 68.4411 72.0342 67.3226 72.1463L67.3608 72.5277Z",
    fill: "url(#paint4_linear_112_1033)",
    fillOpacity: 0.5,
    mask: "url(#path-5-inside-1_112_1033)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_112_1033",
    x: 0.539757,
    y: 0.806236,
    width: 76.9702,
    height: 81.2428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.62398,
    result: "effect1_foregroundBlur_112_1033"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_112_1033",
    x: 4.86579,
    y: 2.55927,
    width: 101.006,
    height: 107.114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.0464
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_112_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_112_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_112_1033",
    x: 26.3647,
    y: 25.4033,
    width: 59.649,
    height: 63.2431,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.18665
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_112_1033"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.7911,
    dy: 4.7911
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.74932
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.15375 0 0 0 0 0.522433 0 0 0 0 0.9 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_112_1033",
    result: "effect2_dropShadow_112_1033"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_112_1033",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_112_1033",
    x1: 32.4873,
    y1: 13.0348,
    x2: 48.472,
    y2: 72.6907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5DA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6DC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_112_1033",
    x1: 55.3261,
    y1: 25.4782,
    x2: 55.3261,
    y2: 87.2384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5DA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E6DC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_112_1033",
    x1: 36.6309,
    y1: 32.6895,
    x2: 87.5319,
    y2: 77.4081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_112_1033",
    x1: 67.6689,
    y1: 45.6599,
    x2: 35.3742,
    y2: 46.5967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_112_1033",
    x1: 43.8605,
    y1: 50.7056,
    x2: 68.4737,
    y2: 50.8265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoingWell2);
export default __webpack_public_path__ + "static/media/doing-well2.5751d40263de1a7ba4d851032fa8286a.svg";
export { ForwardRef as ReactComponent };